import { Grid, useTheme } from "@mui/material";
import * as React from "react";

import { useNavigation } from "@/providers";
import { TagsGroup, Tags } from "@/shared/components/tags";
import { useDataset } from "@/shared/domain/datasets/hooks";

import { EditableDatasetDescription } from "./EditableDatasetDescription";
import { EditableDatasetName } from "./EditableDatasetName";

interface DatasetHeaderProps {
  datasetId: string;
  showTags?: boolean;
}

export const DatasetHeader: React.FC<DatasetHeaderProps> = ({
  datasetId,
  showTags,
}) => {
  const theme = useTheme();
  const { goto } = useNavigation();

  const datasetQuery = useDataset(datasetId, { throwOnError: true });

  const goToDatasetsByTag = (tag: string) => {
    const queryParams = new URLSearchParams();
    queryParams.set("query", tag);
    goto.search(queryParams);
  };

  return (
    <Grid container spacing={1}>
      <Grid item sm={5} xs={12}>
        <EditableDatasetName
          datasetId={datasetId}
          name={datasetQuery.data?.name}
          isLoading={datasetQuery.isLoading}
        />
      </Grid>
      {showTags &&
        datasetQuery.data?.tags &&
        datasetQuery.data.tags.length > 0 && (
          <Grid item xs={12} mt={theme.spacing(0.25)}>
            <TagsGroup>
              <Tags
                tags={datasetQuery.data?.tags}
                onClickTag={goToDatasetsByTag}
              />
            </TagsGroup>
          </Grid>
        )}
      <Grid item xs={12}>
        <EditableDatasetDescription
          datasetId={datasetId}
          description={datasetQuery.data?.description}
          isLoading={datasetQuery.isLoading}
        />
      </Grid>
    </Grid>
  );
};
